import React, { useState, useEffect } from "react";
import "./Appointment.css";
import { fetchAppointments } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Appointment: React.FC = () => {
  const navigate = useNavigate(); 
  const location = useLocation(); 

  // Format the date and time from the API response
  const separateDateAndTime = (dateTimeString: string) => {
    const [date, timeWithZone] = dateTimeString.split(" ");  
    const [time] = timeWithZone.split(" ");  
    return { date, time };
  };

  // Fetching appointments from the API
  useEffect(() => {
    const loadAppointments = async () => {
      try {
        const data = await fetchAppointments();

        if (data.count > 0) {
          // Map appointments from the API response
          const formattedAppointments = data.appointments.map((appt: any) => {
            const { date, time } = separateDateAndTime(appt.date);
            return {
              id: appt.id,
              name: appt.appointment_type.name,
              date: date,  
              time: time,  
            };
          });

          setPrevAppointments(formattedAppointments);  
        }
      } catch (err) {
        console.error("Error loading appointments", err);
      }
    };

    loadAppointments();
  }, []);

  // State for previous appointments
  const [prevAppointments, setPrevAppointments] = useState<
    { id: number; name: string; date: string; time: string }[]
  >([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  // Pagination logic
  const totalPages = Math.ceil(prevAppointments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentAppointments = prevAppointments.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  // Handling pagination
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  // Handling Modify Appointment button click
  const handleModifyAppointment = () => {
    if (latestAppointment) {
      const appid = latestAppointment.id;
      const isReschedule = true;  
  
      navigate("/dashboard/schedule_consultation", {
        state: { appointmentId: appid, isReschedule },
      });
    }
  };
  

  // Handling Join List button click
  // const handleJoinList = () => {
  //   console.log("Join List clicked");
  // };

  const latestAppointment = prevAppointments[prevAppointments.length-1];
  const previousAppointments = prevAppointments.slice(1);

  return (
    <div className="schedule-container">
      {/* Current Scheduled Appointment */}
      <h1 className="schedule-heading">Scheduled Appointment</h1>
      <div className="appointment-details">
        {latestAppointment ? (
          <>
            <h3 className="appointment-booked-title">{latestAppointment.name}</h3>
            <div className="appointment-booked-details">
              <p className="appointment-date-heading">
                <strong>Appointment Date</strong>
              </p>
              <p className="appointment-date">{latestAppointment.date}</p>
              <p className="appointment-time">{latestAppointment.time}</p>
            </div>
            <p className="appointment-duration">15 mins duration</p>
            <div className="appointment-buttons">
              <button className="modify-button" onClick={handleModifyAppointment}>
                Modify Appt
              </button>
            </div>
          </>
        ) : (
          <p>No scheduled appointment found.</p>
        )}
      </div>

      {/* Previous Appointments */}
      <h1 className="schedule-heading">Previous Appointments</h1>
      <div className="no-appointment-div">
        {previousAppointments.length > 0 ? (
          <div>
            <div className="appointment-grid">
              {currentAppointments.map((appt, index) => (
                <div key={appt.id} className="appointment-card">
                  <h3 className="prev-appointment-booked-title">{appt.name} {appt.id}</h3>
                  <p className="appointment-date">{appt.date}</p>
                  <p className="appointment-time">{appt.time}</p>
                </div>
              ))}
            </div>
            <div className="pagination-controls">
              <button
                className="pagination-button"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="pagination-info">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="pagination-button"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        ) : (
          <p className="no-appointment-content">
            You currently do not have any previous appointments. If you feel this
            is an error, please contact support.
          </p>
        )}
      </div>
    </div>
  );
};

export default Appointment;
